import React from 'react'
import { FormattedMessage } from 'react-intl'
import deLanguageMap from './de-DE.json'
import enLanguageMap from './en-US.json'

export const defaultLanguage: AvailableLocale = 'de'

export const availableLocales = [ 
  {
    languageCode: 'de', // ISO 639-1 standard
    languageName: <FormattedMessage description='german' id='generic.german' />,
    icon: '🇩🇪',
  },
  {
    languageCode: 'en',
    languageName: <FormattedMessage description='english' id='generic.english' />,
    icon: '🇬🇧',
  }
]

/**
 * Returns the locale of the browser. Fallback: ```'de'```.
 */
export const getLocale = () => {
  const locale = navigator.language
  const isSupported = availableLocales.some((availableLocale) => availableLocale.languageCode === locale)
  
  if (!isSupported) {
    return defaultLanguage
  }

  return locale
}

/**
 * @param language string, must be included in ```availableLocales[languageCode]```
 * 
 * Returns a language File (Json Object) based on the given language.
 * 
 * Language ```en``` returns ```enLanguageMap``` (en-US.json).
 */
export const getLanguageFile = (language: AvailableLocale): LanguageFile => {
  switch (language) {
    case 'de':
      return deLanguageMap
    case 'en':
      return enLanguageMap
    default:
      return deLanguageMap
  }
}

type LanguageFile = {
  [key: string]: string
}

type AvailableLocale = AllAvailableLocales['languageCode']

type AllAvailableLocales = {
  languageCode: string
  languageName: React.ReactNode
  icon: string
}
